import { render, staticRenderFns } from "./AdvantageSection.vue?vue&type=template&id=2c06e022&scoped=true&"
import script from "./AdvantageSection.vue?vue&type=script&lang=js&"
export * from "./AdvantageSection.vue?vue&type=script&lang=js&"
import style0 from "./AdvantageSection.vue?vue&type=style&index=0&id=2c06e022&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c06e022",
  null
  
)

export default component.exports